<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="hideModal()"
  [header]="'SE CONNECTER'"
  styleClass="login-modal">
  <div class="form-container">
    <form class="form" (keydown.enter)="onSubmit()">
      @for (field of loginFields; track $index) {
        <div class="form-field">
          <app-input-field [fieldConfig]="field" [formGroup]="loginForm" [showPasswordRules]="field.showPasswordRules || false"></app-input-field>
          <app-input-field-error [control]="loginForm.get(field.name)" [fieldName]="field.name"></app-input-field-error>
        </div>
      }

      <div class="submit-button">
        <button id="connexion-submit-button" type="submit" class="register-btn" [disabled]="loginForm.invalid" (click)="onSubmit()">
          Se connecter
        </button>
      </div>
      <app-input-field-error [globalError]="error"></app-input-field-error>
      <div class="helper-action-container">
        <button type="button" class="action-btn" (click)="onForgotPassword()">Mot de passe oublié ?</button>
      </div>

      <div class="helper-action-container">
        <button type="button" class="action-btn" (click)="onNoAccount()">Pas de compte ?</button>
      </div>
    </form>
  </div>
</p-dialog>
